/**
 * Rank labels for typeahead so exact / prefix matches beat long substring hits.
 * Example: query "Tablet" → "Tablet" before "TabletAcenacoumarol" / "FooTablet".
 */

/**
 * Lower rank number = better match.
 * 0 exact, 1 starts-with, 2 contains (prefer shorter names).
 */
export function labelSearchRank(name, query) {
  const n = String(name || '').toLowerCase();
  const q = String(query || '').trim().toLowerCase();
  if (!q) {
    return 3;
  }
  if (n === q) {
    return 0;
  }
  if (n.startsWith(q)) {
    return 1;
  }
  if (n.includes(q)) {
    return 2;
  }
  return 4;
}

/**
 * Sort labels by search relevance, then name length, then alphabetical name.
 * Does not filter; callers should filter first if needed.
 */
export function sortLabelsBySearchRelevance(labels, query) {
  const q = String(query || '').trim();
  if (!q) {
    return [...(labels || [])].sort((a, b) =>
      String(a?.name || '').localeCompare(String(b?.name || ''), undefined, {
        sensitivity: 'base',
      }),
    );
  }
  return [...(labels || [])].sort((a, b) => {
    const na = String(a?.name || '');
    const nb = String(b?.name || '');
    const ra = labelSearchRank(na, q);
    const rb = labelSearchRank(nb, q);
    if (ra !== rb) {
      return ra - rb;
    }
    if (na.length !== nb.length) {
      return na.length - nb.length;
    }
    return na.localeCompare(nb, undefined, { sensitivity: 'base' });
  });
}

/**
 * Filter labels whose name contains query (case-insensitive), rank, then limit.
 */
export function filterAndRankLabelsForSearch(labels, query, { limit = 50, type = null } = {}) {
  const q = String(query || '').trim().toLowerCase();
  const ft = type == null || type === '' ? null : Number(type);
  let matched = (labels || []).filter((l) => {
    if (!l || !l.name) {
      return false;
    }
    if (ft != null && !Number.isNaN(ft) && Number(l.type) !== ft) {
      return false;
    }
    if (!q) {
      return true;
    }
    return String(l.name).toLowerCase().includes(q);
  });
  matched = sortLabelsBySearchRelevance(matched, q);
  const lim = limit != null ? Number(limit) : 50;
  if (lim > 0) {
    return matched.slice(0, lim);
  }
  return matched;
}
